import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { RenewalQuotesProvider } from '../../../pages/quotation/SavedQuotes/shared/contexts/RenewalQuotes';

const InsurancePolicyListPage = lazy(() => import('../../../pages/').then(module => ({ default: module.InsurancePolicyListPage })));
const InsurancePolicyDetail = lazy(() => import('../../../pages/').then(module => ({ default: module.InsurancePolicyDetail })));
const TotalProduction = lazy(() => import('../../../pages/').then(module => ({ default: module.TotalProductionPage })));
const RubricatedBooksListPage = lazy(() => import('../../../pages/').then(module => ({ default: module.RubricatedBooksListPage })));

export const productionChildrenRoutes = [
  {
    path: '',
    element: <Navigate to={'listado-de-polizas'} />,
  },
  {
    path: 'listado-de-polizas',
    element: <InsurancePolicyListPage title='Listado de Pólizas' />,
  },
  {
    path: 'detalle-de-poliza/:id',
    element: (
      <RenewalQuotesProvider>
        <InsurancePolicyDetail title='Detalle de Póliza' />
      </RenewalQuotesProvider>
    ),
  },
  {
    path: 'total-de-produccion',
    element: <TotalProduction title='Total de Producción' />,
  },
  {
    path: 'libros-rubricados',
    element: <RubricatedBooksListPage  title='Libros Rubricados' />,
  },
];
